// src/services/api/businessSetup.js
import { apiClient } from './base';

/**
 * Get current setup progress
 * @returns {Promise<Object>} Setup progress data
 */
export const getSetupProgress = async () => {
  try {
    const response = await apiClient.get('/business/setup/progress');
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update a specific setup step
 * @param {Object} stepData - Step update data
 * @param {string} stepData.stepName - Name of the step to update
 * @param {boolean} stepData.completed - Whether the step is completed
 * @returns {Promise<Object>} Updated progress data
 */
export const updateSetupStep = async (stepData) => {
  try {
    const response = await apiClient.put('/business/setup/progress', stepData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update multiple setup steps at once
 * @param {Object} stepsData - Steps update data
 * @param {Object} stepsData.steps - Object with step names as keys and completion status as values
 * @returns {Promise<Object>} Updated progress data
 */
export const updateMultipleSteps = async (stepsData) => {
  try {
    const response = await apiClient.put('/business/setup/progress/batch', stepsData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Mark setup as completed
 * @returns {Promise<Object>} Completion status
 */
export const completeSetup = async () => {
  try {
    const response = await apiClient.post('/business/setup/complete');
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Force mark setup as completed (admin override)
 * @returns {Promise<Object>} Completion status
 */
export const forceCompleteSetup = async () => {
  try {
    const response = await apiClient.post('/business/setup/force-complete');
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Reset setup progress (for testing or re-onboarding)
 * @returns {Promise<Object>} Reset progress data
 */
export const resetSetupProgress = async () => {
  try {
    const response = await apiClient.post('/business/setup/reset');
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Initialize setup progress for existing businesses
 * @returns {Promise<Object>} Initialized progress data
 */
export const initializeSetupProgress = async () => {
  try {
    const response = await apiClient.post('/business/setup/initialize');
    return response.data;
  } catch (error) {
    throw error;
  }
};